module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-why-testimonials"
  }, [_c('div', {
    staticClass: "custom-why-testimonials__container"
  }, [_c('div', {
    staticClass: "custom-why-testimonials__video-gallery"
  }, _vm._l((_vm.props.video_testimonials), function(testimonial, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-why-testimonials__gallery-item",
      style: ({
        backgroundImage: 'url(' + testimonial.bg + ')'
      }),
      on: {
        "click": function($event) {
          return _vm.openTestiModial(testimonial.src)
        }
      }
    }, [_c('div', {
      staticClass: "custom-why-testimonials__overlay"
    }), _c('div', {
      staticClass: "custom-why-testimonials__overlay-text",
      domProps: {
        "innerHTML": _vm._s(testimonial.text)
      }
    }), _c('Icon', {
      staticClass: "custom-why-testimonials__play-btn",
      attrs: {
        "name": "triangle"
      }
    })], 1)
  }), 0), _c('div', {
    staticClass: "custom-why-testimonials__wrapper"
  }, [_c('Icon', {
    staticClass: "custom-why-testimonials__quote-icon",
    attrs: {
      "name": "quote"
    }
  }), _c('swiper', {
    ref: "mySwiper",
    staticClass: "custom-why-testimonials__slider-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.slides), function(slide, j) {
    return _c('swiper-slide', {
      key: j,
      staticClass: "custom-why-testimonials__slider"
    }, [_c('div', {
      staticClass: "custom-why-testimonials__slide-text",
      domProps: {
        "innerHTML": _vm._s(slide.text)
      }
    }), _c('div', {
      staticClass: "custom-why-testimonials__slide-author",
      domProps: {
        "innerHTML": _vm._s(slide.author)
      }
    })])
  }), _c('div', {
    staticClass: "custom-why-testimonials__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2), _c('div', {
    staticClass: "custom-why-testimonials__next",
    on: {
      "click": _vm.slideNext
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-down"
    }
  })], 1), _c('div', {
    staticClass: "custom-why-testimonials__prev",
    on: {
      "click": _vm.slidePrev
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-down"
    }
  })], 1)], 1)]), _c('Icon', {
    staticClass: "custom-why-testimonials__footer-divider",
    attrs: {
      "name": "patient-top-blue"
    }
  }), _c('transition', {
    staticClass: "custom-why-testimonials__modal-transition",
    attrs: {
      "name": "fade-in-out"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modalActive),
      expression: "modalActive"
    }],
    staticClass: "custom-why-testimonials__modal"
  }, [_c('div', {
    staticClass: "custom-why-testimonials__modal-overlay",
    on: {
      "click": _vm.closeTestiModial
    }
  }, [_c('div', {
    staticClass: "custom-why-testimonials__modal-container"
  }, [_c('div', {
    staticClass: "custom-why-testimonials__modal-close",
    on: {
      "click": _vm.closeTestiModial
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "custom-why-testimonials__modal-content"
  }, [_c('video', {
    staticClass: "custom-why-testimonials__video",
    attrs: {
      "src": _vm.videoTestimonial,
      "type": "video/mp4",
      "controls": "controls",
      "controlsList": "nodownload"
    }
  }, [_c('p', [_vm._v("Your browser doesn't support HTML5 video.     ")])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16cb0e6c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-why-testimonials/custom-why-testimonials.pug
// module id = 663
// module chunks = 1